import { makeStyles } from 'tss-react/mui';

export const useChatMessageFormStyles = makeStyles()(() => ({
  wrapper: {
    padding: '8px',
    pointerEvents: 'auto',
    border: '0.5px solid rgba(0, 0, 0, 0.10)',
    boxShadow: '0px 2px 16px -4px rgba(0, 0, 0, 0.20)',
  },
  input: {
    width: '100%',
    border: '0px',
    resize: 'none',
    alignSelf: 'center',
    '&:focus': {
      outline: 'none',
    },
  },
}));
